// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Jwe_o","bounce":"styles_bounce__K3l0K"};